import { Controller } from "@hotwired/stimulus"

// Seconds since a moment, ticking: "8s", "1m 04s". For the narrated
// timeline's live line, as a coding agent's status line counts its work.
// Usage: data-controller="elapsed" data-elapsed-since-value="<ISO time>".
export default class extends Controller {
  static values = { since: String }

  connect() {
    this.render()
    this.timer = setInterval(() => this.render(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  render() {
    const since = Date.parse(this.sinceValue)
    if (Number.isNaN(since)) return
    const seconds = Math.max(0, Math.round((Date.now() - since) / 1000))
    const minutes = Math.floor(seconds / 60)
    this.element.textContent = minutes > 0 ? `${minutes}m ${String(seconds % 60).padStart(2, "0")}s` : `${seconds}s`
  }
}
